import { Component, Input , Output, ElementRef, ViewChild, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { RequestService } from '../../service/api/request.service';
import { StorageService } from '../../service/storage/storage.service';
import { ShareDataService } from '../../service/share-data/share-data.service';
import { AuthGuardService } from '../../service/auth/auth-guard.service';


@Component({
  selector: 'app-userlogin',
  templateUrl: 'userlogin.component.html',
  styleUrls: ['./userlogin.component.scss']
})
export class UserloginComponent { 
  @ViewChild("loginForm") loginForm: ElementRef;
  form: FormGroup;
  loading = false;
  submitted = false;
  isSuccessful = false;
  isSignUpFailed = false;
  errorMessage = '';
  returnUrl: string;
  userAccount;
  username = '';
  password = '';
  user = this.storageService.getStorage('user') || [];
  @Input() accountId!: string;
  @Input()  token:any;
  @Output() tokenSet = new EventEmitter<any>();
  @Output() loginError = new EventEmitter<any>();
  @Input() continueForgotpassRegister;
  @Output() setContinueRegisterParent = new EventEmitter<any>();
  @Input() setting:any;
  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private requestService: RequestService,
    private storageService : StorageService,
    private shareDataService: ShareDataService
  ){
  }

async  ngOnInit() {

    this.form = this.formBuilder.group({
        username: ['', Validators.required],
        password: ['', Validators.required]
    });
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';

    this.shareDataEventListener()
  }

get f() { return this.form.controls; }

shareDataEventListener(){
  this.shareDataService.currentMessage.subscribe((res) => {
    try {
      let msg = JSON.parse(res);
      console.log('UserloginComponent msg:', msg);
      if (msg.event == 'FOCUS_LOGIN'){
        this.setFocus('username')
      }
    } catch (error) {
      console.log('UserloginComponent shareDataEventListener:', error);
    }
  })
}

async onSubmit() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.form.invalid) {
        return;
    }
    if (!this.accountId) {
      console.error('Account ID is missing');
      return;
  }
    let parentApi =  this.requestService.getParentAPI();
    
    let requestBody: { username: string; password: string; acc_id: string } = { username: '', password: '', acc_id: '' };
    requestBody.username = this.f.username.value;
    requestBody.password = this.f.password.value;
    requestBody.acc_id = this.accountId;

    try {
      let res = await parentApi.post(parentApi.route.login,requestBody,{})
      await this.storageService.setStorage('user',JSON.stringify(res));
      this.user = await this.storageService.getStorage('user');
      this.tokenSet.emit(this.user);
      this.loading = true;

      let msg = JSON.stringify({
        event: AuthGuardService.EVENT.LOGIN_SUCCESS,
      })
      this.shareDataService.changeMessage(msg)

    } catch (ex) {
        let status = ex.message.response.status
        let statusText = ex.message.response.statusText
        console.log('login component userlogin err => ',status, ex); // get error for check login => status, ex
        let msg = JSON.stringify({
          event: AuthGuardService.EVENT.LOGIN_ERROR,
          data: {
            status: status,
            success: false,
            statusText: statusText
          }
        })
        this.shareDataService.changeMessage(msg)
        
      } // End catch
  }

  setFocus(name) {
    const ele = this.loginForm.nativeElement[name];
    if (ele) {
      this.username = '';
      this.password = '';
      ele.focus();
    }
  }
  
}
